// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1owLN","content":"styles_content__2rY0f","row":"styles_row__1eSSI","footer":"styles_footer__3X5Nh","phraseLength":"styles_phraseLength__1mA5W"};